// extracted by mini-css-extract-plugin
export default {"container":"a2al1NIQ"};